module.exports = __webpack_public_path__ + "static/img/14000138.11e2387a.png";